var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCronosCruiser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 17,
    viewBox: "0 0 27 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6455 11.4667H22.2355C23.4404 11.4667 24.5328 10.7738 25.0405 9.68799H21.4505C20.2456 9.68799 19.1533 10.3809 18.6455 11.4667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.20099 9.92772H7.91914C8.77546 9.92772 9.55494 9.43395 9.91724 8.66191L6.79383 8.65918L6.19824 9.92772H6.20099Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9389 2.57849L21.7595 0.799805H11.9227C6.98512 0.799805 3.57627 2.57849 1.78676 7.91182H4.25146L1.00454 14.9938C0.919456 15.0293 0 15.4412 0 16.7998H7.67677C9.8423 16.7998 11.9529 16.1778 13.7644 15.0211H17.1623C18.3672 15.0211 19.4595 14.3282 19.9673 13.2424H15.8256C16.2236 12.7541 16.5612 12.2167 16.8219 11.6383L18.5044 7.9091H20.4476C21.6525 7.9091 22.7449 7.21617 23.2526 6.13041H19.3058L19.6764 5.30927L20.1183 4.35172H24.0266C25.2315 4.35172 26.3239 3.6588 26.8317 2.57304H20.9389V2.57849ZM8.14336 13.0187L8.02534 13.2506C7.46818 14.3418 6.34013 15.0266 5.10779 15.0184C4.38869 15.0129 3.59549 15.0075 2.89286 15.002L6.14252 7.91455H14.0059L12.6748 10.8336L11.7581 10.8281C10.232 10.8199 8.83227 11.6683 8.14336 13.0215V13.0187Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCronosCruiser);
export default __webpack_public_path__ + "static/media/cronos-cruiser.82adcba0edcbdb248490cf34b2052906.svg";
export { ForwardRef as ReactComponent };